import React from "react";
import { Flex } from "@chakra-ui/core";

import Content from "~/ui/structure/Content";
import PlanCard from "./PlanCard";
import { PLANS } from "~/constanst/plans";

const PlansPrices: React.FC = () => {
  return (
    <Content
      paddingX={6}
      paddingY={{ base: 3, md: 8 }}
    >
       <Flex 
        align-self="start" 
        justifyContent='space-between'
        my={{base: 4, md: 3}}
        alignItems={{base: "center", md: 'inherit'}}
        flexDirection={{base: "column", md: 'row'}}
      >
        {PLANS.map((plan, index) => {
          return <PlanCard plan={plan} key={index}/>
        })}
      </Flex>
    </Content>
  );
};

export default PlansPrices;
